import { Box, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import ChipComponent from "../../../../../common/components/chip/ChipComponent";
import { useState } from "react";
import { useGetDevicesByLocation } from "../hooks/useGetDevicesByLocation";

interface IConnectedDevicesColumnProps {
  params: any;
}

function ConnectedDevicesColumn({ params }: IConnectedDevicesColumnProps): any {
  const [isShowMore, setIsShowMore] = useState(false);

  const { row, isItAdminRole = false } = params;
  const { rowId: locationId } = row;
  const { data, loading } = useGetDevicesByLocation(locationId);

  const devices = data?.getDevicesByLocation?.items;
  const onSetShowMoreHandler = () => setIsShowMore(prev => !prev);

  if (loading) {
    return (
      <Box sx={{ width: "100px" }}>
        <Skeleton />
      </Box>
    );
  }

  return (
    <Grid sx={{ margin: "12px 0" }} container spacing={1}>
      {devices?.map((device, index) => {
        if (index > 1 && !isShowMore) {
          return null;
        }

        const devicePageLink = isItAdminRole
          ? `/device/${encodeURIComponent(device?.id ?? "")}`
          : "";

        return (
          <Grid item key={index}>
            <Stack spacing={1} direction="row" alignItems="center">
              {index === 1 && !isShowMore ? (
                <ChipComponent
                  menuBoxStyles={{
                    padding: "2px 0.5em",
                    color: theme => theme.typography.inputLabel.color,
                  }}
                  onClick={onSetShowMoreHandler}
                  label={`+${devices.length - 1}`}
                />
              ) : (
                <ChipComponent
                  menuBoxStyles={{
                    padding: "2px 0.5em",
                  }}
                  label={device?.name ?? ""}
                  routeLink={devicePageLink}
                />
              )}

              {index === devices?.length - 1 && isShowMore && (
                <ChipComponent
                  menuBoxStyles={{
                    padding: "2px 0.5em",
                    color: theme => theme.palette.primary.dark,
                  }}
                  onClick={onSetShowMoreHandler}
                  label={"Show less"}
                />
              )}
            </Stack>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default ConnectedDevicesColumn;
